var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2.64451C31.6324 1.90088 29.113 1.5 26.5 1.5C12.6929 1.5 1.5 12.6929 1.5 26.5C1.5 40.3071 12.6929 51.5 26.5 51.5C40.3071 51.5 51.5 40.3071 51.5 26.5C51.5 22.2117 50.4203 18.1755 48.5179 14.6486M39 10.875H39.0125M22.7501 51.2206L22.7504 45.7123C22.7504 45.414 22.8572 45.1254 23.0513 44.8989L29.2658 37.6485C29.7765 37.0527 29.6182 36.1391 28.9369 35.7497L21.7963 31.6693C21.6023 31.5585 21.4416 31.3976 21.3308 31.2036L16.6761 23.0466C16.4339 22.622 15.9664 22.3777 15.4796 22.421L1.66046 23.6519M49 11.5C49 17.0228 44 21.5 39 26.5C34 21.5 29 17.0228 29 11.5C29 5.97715 33.4772 1.5 39 1.5C44.5228 1.5 49 5.97715 49 11.5ZM39.625 10.875C39.625 11.2202 39.3452 11.5 39 11.5C38.6548 11.5 38.375 11.2202 38.375 10.875C38.375 10.5298 38.6548 10.25 39 10.25C39.3452 10.25 39.625 10.5298 39.625 10.875Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.47b322bb6e7bf9729101ae92813cbf93.svg";
export { ForwardRef as ReactComponent };